import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTPARAMETERSMODALLAUNCHERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  cartParametersModalLauncherBlockDescriptor: _generatedCartParametersModalLauncherBlockDescriptor,
  cartParametersModalLauncherBlockBlocDefinition,
  cartParametersModalLauncherBlockDashboardLayout,
  cartParametersModalLauncherBlockConfig,
  cartParametersModalLauncherBlockResolveConfig,
  cartParametersModalLauncherBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal launcher / Cart parameters",
    componentType: 'CartParametersModalLauncherBlockComponent',
    category: 'system',
    description: "Modal launcher / Cart parameters.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function cartParametersModalLauncherBlockDescriptor(): IBlockDescriptor;
export function cartParametersModalLauncherBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartParametersModalLauncherBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartParametersModalLauncherBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartParametersModalLauncherBlockDescriptor, cartParametersModalLauncherBlockProperties, fieldOrder);
}

export {
  cartParametersModalLauncherBlockBlocDefinition,
  cartParametersModalLauncherBlockDashboardLayout,
  cartParametersModalLauncherBlockProperties,
  cartParametersModalLauncherBlockConfig,
  cartParametersModalLauncherBlockResolveConfig,
};

export type CartParametersModalLauncherBlockConfig = typeof cartParametersModalLauncherBlockConfig;
